// extracted by mini-css-extract-plugin
export var container = "PickSlipAlert-module--container--88f56";